import { createAction, props } from '@ngrx/store';

export const setTransactionTab = createAction(
    '[Transaction Tab] Set Transaction Tab',
    props<{ pageId: string; tabIndex: number }>(),
);

export const resetTransactionTab = createAction(
    '[Transaction Tab] Reset Transaction Tab',
    props<{ pageId: string }>(),
);
